import { logger } from '@waitroom/logger';
import { onLoadError } from '../../core/services/serviceWorker';

export const onError = (err: Error) => {
  logger.report(err);
  onLoadError(err);
};
